import React, { useEffect, useState } from 'react'
import { GetAction } from '../../Component/GetAction'
import PaymentReceipt from '../../View/PaymentReceipt'
import ManageTable from '../ManageTable'
import {
  RequireModule,
  PageHeader,
  formatInr,
  downloadCsv,
} from './shared'

function DonationReportsPage() {
  const [rows, setRows] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)
  const [receipt, setReceipt] = useState(null)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      setLoading(true)
      const data = await GetAction('get', { status: 'paid' }, 'donation/donationList')
      if (cancelled) return
      if (data?.status === 'success' && Array.isArray(data.response)) {
        setRows(data.response)
        setError('')
      } else {
        setError(data?.message || 'Failed to load donation report.')
        setRows([])
      }
      setLoading(false)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  const columns = [
    { key: 'index', label: '#', width: '60px' },
    { key: 'name', label: 'Name' },
    {
      key: 'mobile',
      label: 'Mobile',
      render: (row) => row.mobile || '—',
    },
    {
      key: 'mode_of_payment',
      label: 'Mode',
      render: (row) => row.mode_of_payment || row.payment_mode || '—',
    },
    {
      key: 'payment_amount',
      label: 'Amount',
      render: (row) => formatInr(row.payment_amount),
    },
    { key: 'created_at', label: 'Date' },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <button
          type="button"
          className="btn btn-sm btn-outline-danger"
          onClick={() => setReceipt(row)}
        >
          Print Receipt
        </button>
      ),
    },
  ]

  const exportRows = () => {
    downloadCsv(
      'donation-reports.csv',
      [
        { key: 'index', label: '#' },
        { key: 'name', label: 'Name' },
        { key: 'mobile', label: 'Mobile' },
        {
          key: 'mode',
          label: 'Mode',
          get: (r) => r.mode_of_payment || r.payment_mode || '',
        },
        { key: 'payment_amount', label: 'Amount' },
        { key: 'created_at', label: 'Date' },
        { key: 'transaction_id', label: 'Txn' },
      ],
      rows
    )
  }

  return (
    <RequireModule moduleKey="donation_reports">
      <PageHeader
        title="Donation Reports"
        subtitle="Donation history with receipt print."
        actions={
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={exportRows}
            disabled={!rows.length}
          >
            Export CSV
          </button>
        }
      />
      {error ? <div className="manage-alert manage-alert-err">{error}</div> : null}
      <div className="manage-card">
        {loading ? (
          <div className="text-center py-4">
            <div className="spinner-border text-warning" role="status" />
          </div>
        ) : (
          <ManageTable
            columns={columns}
            rows={rows}
            searchKeys={[
              'name',
              'mobile',
              'mode_of_payment',
              'payment_mode',
              'payment_amount',
              'created_at',
            ]}
          />
        )}
      </div>
      {receipt ? (
        <PaymentReceipt
          hide={() => setReceipt(null)}
          title="Donation History"
          data={receipt}
        />
      ) : null}
    </RequireModule>
  )
}

export default DonationReportsPage
